import {Evaluator, registerNode} from "@cm/graph-v2-final"
import {ImageOpNodeRasterizeGeometry} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/rasterize-geometry/node"
import {definition} from "@app/textures/texture-editor/operator-stack/operators/tiling/node/apply-mapping/definition"
import {AnyImageOpContext, ImageOpOutputs} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"
import {CompositeImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/composite-image-op-node"
import {Definition} from "@app/textures/texture-editor/operator-stack/operators/test/node/definition"

@registerNode
export class ImageOpNodeTilingApplyMapping extends CompositeImageOpNode<typeof definition> {
    static nodeClass = "ImageOpNodeTilingApplyMapping"
    static definition = definition

    override async execute(evaluator: Evaluator<AnyImageOpContext>, imageOpNodeBag: ImageOpNodeBag): Promise<ImageOpOutputs<typeof Definition>> {
        const {sourceImage, gridGeometry, resultSize} = await evaluator.getAll(this.parameters)
        const result = imageOpNodeBag.getNode("rasterizeGeometry", ImageOpNodeRasterizeGeometry, {
            geometry: gridGeometry,
            textureImage: sourceImage,
            addressMode: "clamp",
            descriptor: {
                ...sourceImage.descriptor,
                ...resultSize,
            },
        })
        return await evaluator.get(result)
    }
}
